import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as commonActions from 'modules/common/actions';
import { withRouter, Switch, Route } from 'react-router-dom';
import Alert from 'react-s-alert';
import AlertTemplate from 'modules/common/alert/AlertTemplate';

// PUBLIC
import PageNotFound from 'modules/partial/PageNotFound';

// PRIVATE
import Inquire from 'modules/biller/container/Inquire';
// import Billers from 'modules/biller/container/Billers';
import Categorized from 'modules/biller/container/Categorized';
import BillerWithBack from 'modules/biller/container/BillerWithBack';
import BillerSummary from 'modules/biller/container/BillerSummary';
import Biller from 'modules/biller/container/Biller';
import PaySuccess from 'modules/biller/container/PaySuccess';

// FONTAWESOME

class App extends Component {
  static propTypes = {
    setModal: PropTypes.func.isRequired,
  }

  static childContextTypes = {
    setModal: PropTypes.func,
  }

  getChildContext() {
    const { setModal } = this.props;
    return {
      setModal,
    };
  }

  componentDidMount() {
    console.log('%cBPF Version 1.0', 'color:#5c88d6'); // eslint-disable-line
  }

  render() {
    return (
      <React.Fragment>
        <Switch>
          <Route path="/:inquiry_no/biller/:biller_code/summary" component={BillerSummary} />
          <Route path="/:inquiry_no/biller/:biller_code" component={Biller} />
          <Route path="/:inquiry_no/billers/:biller_code/summary" component={BillerSummary} />
          <Route path="/:inquiry_no/billers/:biller_code" component={BillerWithBack} />
          <Route path="/:inquiry_no/billers" component={Categorized} />
          <Route path="/:inquiry_no/success" component={PaySuccess} />
          <Route path="/:inquiry_no" component={Inquire} />
          <Route component={PageNotFound} />
        </Switch>
        <Alert
          stack={{ limit: 1 }}
          effect="slide"
          contentTemplate={AlertTemplate}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ modal, profile }) => ({
  modal,
  profile,
});

const mapDispatchToProps = {
  ...commonActions,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
